/**
 * VERSIONE LIBRERIA 3.0
 */
var BaseElement = Class.extend({
    _modeValidateFunctionName : {
        'view'   : '_validateView',
        'edit'   : '_validateEdit',
        'search' : '_validateSearch'
    },
    _modeRenderFunctionName : {
        'view'   : '_renderView',
        'edit'   : '_renderEdit',
        'search' : '_renderSearch'
    },
    _modeFinalizeFunctionName : {
        'view'   : '_finalizeView',
        'edit'   : '_finalizeEdit',
        'search' : '_finalizeSearch'
    },
});
BaseElement.VIEW = 'view';
BaseElement.EDIT = 'edit';
BaseElement.SEARCH = 'search';

var Render = BaseElement.extend({
    key : null,                 // chiave dell'oggetto render (il campo del db)
    type : null,                // type dell'oggetto per gestire le Gerarchie di classi
    className : 'Render',       // nome della Classe reale dell'oggetto
    classData : null,           // nome per il tipo di caricamento dati e config da utilizzare nelle views
                                // per permettere caricamenti custom per oggetti particolari
    classTemplate : null,       // nome utilizzato per la composozione del templateid da caricare
    prefixTemplateClass : 'default',    // prefisso utilizzato per la costruzione del template id

    element_selector : '[data-render_element]',
    control_selector : '[data-render_control]',
    caption_selector : '[data-render_caption]',
    modes : ['edit','view','search'],           // modi accettati
    value : null,           // valore oggetto
    mode : 'edit',          // modo in edit controllo di form, default edit
    templateId : null,      // id del template sorgente da renderizzare,
    templateItemId : null,  // id del template in caso di oggetti che sono vettori di valori
    container : null,       // id del container html dove verrà renderizzato l'oggetto Render


    // costruttore
    init : function (key,attributes) {
        this.key = key;
        this.attrs(attributes);
    },

    attrs : function (attrs) {
        var self = this;
        if (attrs) {
            for (var k in attrs) {
                // if (_.isFunction(attrs[k])) {
                //     self.prototype[k] = attrs[k];
                // } else
                    self[k] = attrs[k];
            }
            return self;
        }
        // se attrs non settato si vogliono leggere gli attributi
        var attrs = [];
        for(var k in window[self.className].prototype) {
            // rimuovo i campi speciali
            if ($.inArray(k,['type','_modeRenderFunctionName','_modeFinalizeFunctionName','modes','_modeValidateFunctionName']) >= 0)
                continue;
            if (_.isFunction(self[k])) {
                //log.info('function ' + i);
            } else if (_.isObject(self[k]) ) {
                attrs.push(k);
            } else {
                //log.info('attribute ' + i);
                attrs.push(k);
            }

        }
        return attrs;//_.sortBy(attrs);
    },
    /**
     * esegue il render dell'oggetto chiamando il metodo _render
     * @param [container]: opzionale,se passato assegna l'html generato
     * @return stringa contenente l'html generato
     **/
    render : function (container) {
        var self = this;
        var obj = self._getTemplate();
        if (obj.children().length > 0) {
            $(obj.children()[0]).attr('data-render_id',self.key);
        }
        if (!_.isFunction(self[self._modeRenderFunctionName[self.mode] ]))
            throw self.type + "." + self._modeRenderFunctionName[self.mode] +  " not implemented";

        self[self._modeValidateFunctionName[self.mode] ](obj);
        //try {
        self[self._modeRenderFunctionName[self.mode] ](obj);
        //} catch (e) {
        //console.error(e);
        //throw self.type + "." + self.modeRenderFunctionName[self.mode]  + " error! ->  " + e.message;
        //   return;
        //}
        //self._render(obj)
        var html = obj.html();
        if (container) {
            self.container = container;
        }
        if (self.container)
            $(self.container).html(html);
        obj.remove();
        return html;
    },
    /**
     * esegue il finalize dell'html chiamando il metodo _finalize
     * usare _finalize per la generazione di eventi o gestione del codice html
     * @param callback : [opzionale] callaback chiamata alla fine del finalize
     **/
    finalize : function (callback) {
        var self = this;
        callback = callback || function () {};
        if (!_.isFunction(self[self._modeFinalizeFunctionName[self.mode] ])) {
            log.warn('is not function ' + self.type+ "." + self._modeFinalizeFunctionName[self.mode] );
            return callback();
            //throw self.type + "." + self.modeFinalizeFunctionName[self.mode] +  " not implemented";
        }
        //try {
        self[self._modeFinalizeFunctionName[self.mode] ]();
        //} catch (e) {

        //    throw self.type + "." + self.modeFinalizeFunctionName[self.mode]  + " error! ->  " + e.message;
        //    return;
        //}


        //self._finalize();
        return callback();
    },

    /**
     * setta il valore nel controllo html dell'oggetto render
     */
    setValue : function (value) {
        var self = this;
        var renderClass = "Render" + Utility.pascalCase(self.type);
        if (!_.isFunction(self['_set'+renderClass+"Value"]))
            throw '_set'+renderClass+"Value" + " not yet implemented";
        self['_set'+renderClass+'Value'](value);
    },

    _setRenderTextareaValue : function (value) {
        var self = this;
        log.debug('_setRenderTextareaValue')
        $(self.container).find('textarea[name="'+self.key+'"]').html(value);
    },

    _setRenderInputValue : function (value) {
        var self = this;
        log.info('_setRenderInputValue',$(self.container).find('input[name="'+self.key+'"]'))
        $(self.container).find('input[name="'+self.key+'"]').attr('value',value).val(value);
    },
    /**
     * ritorna il valore a runtime dentro html del campo associato al render
     */
    getValue : function () {
        var self = this;
        if (!self.container)
            return null;
        switch(self.type) {
            case 'text':
                return $(self.container).find(self.control_selector).html();
            case 'input':
            case 'select':
                return $(self.container).find(self.control_selector).val();
            case 'decimal':
                if (self.mode == self.VIEW)
                    return self.data.value
                return $(self.container).find(self.control_selector).val();
            case 'choice':
                if (self.choiceType == 'checkbox') {
                    var allVals = [];
                    $(self.container).find(self.control_selector+":checked").each(function() {
                        allVals.push($(this).val());
                    });
                    return allVals;
                }
                //log.info(self.container,self.control_selector+":checked");
                return $(self.container).find(self.control_selector+":checked").val();
            case 'textarea':
                return $(self.container).find(self.control_selector).html();
            case 'swap':
                return self.data.value;
        }
        throw 'Render' + self.type +'.getValue not implemented';

        // vecchio codice
        // in caso di lista di valori devo cercare il valore nel subset dato dall'id (numero riga) dell'oggetto render nella view
        var subset = $(self.container).find('[data-render_id="' + render_id + '"]');

        var container = subset.length > 0 ? subset:$(self.container);
        var selector = "";
        switch(self.cfield.type) {
            case 'input':
            case 'select':
                selector = self.cfield.type+'[name="'+self.key+'"]';
                break;
            case 'date_picker':
                selector = 'input[name="'+self.key+'"]';
                break;
        }
        console.log(self.cfield.type,container,selector);
        return $(container).find(selector).val();
    },

    _getTemplate : function () {
        var self = this;
        var tplId = self.templateId;
        if (!tplId) {
            var firstTpl = '#'+self.prefixTemplateClass+"_"+self.classTemplate+"_"+self.mode+"_tpl";
            var secondTpl = '#'+self.prefixTemplateClass+"_"+self.classTemplate+"_tpl";
            tplId = firstTpl;
            if ($(firstTpl).length == 0) {
                tplId = secondTpl;
                if ($(secondTpl).length == 0) {
                    throw self.key + " template source " + firstTpl + " and alternative template " + secondTpl + " Not found ";
                }
            }

        }

        return $.createDynamicContainer(tplId);
    },

    _validateEdit : function() {
        return true;
    },
    _validateView : function() {
        return true;
    },
    _validateSearch : function() {
        return true;
    },
    // --- abstract metod
    // obsoleti
    /**
     * metodo da overloadare che verra' richiamato in seguito dall'oggetto Render.
     * @param jQe : elemento jquery contenente il template sorgente

    _render : function (jQe) {
        throw '_render Not implemented';
    },

    _finalize : function () {
        throw '_finalize Not implemented';
    },

     */
    _emitEvent : function (eventName,params) {
        var self = this;
        //log.debug("emit",eventName,params);
        var evt = new RenderEvent(eventName,self.type);
        evt.params = params;
        evt.key = self.key;
        self.fireEvent(evt);
    },

    // --- events ------
    fireEvent : function (evt) {
        var self = this;
        log.warn("Render.fireEvent " + evt.eventName + " of " + evt.type + " not overloaded");
        return ;
    },


    /**
     * ritorna il container su cui andare a cercare eventuali controlli o pezzi di html dell'oggetto render
     * controlla se l'oggetto e' in una lista o no in quel caso prende come container una subarea

     getContainer : function () {
        var self = this;
        var container =  $(self.container);
        if (self.index) {
            container =  $(self.container).find('[data-render_id="' + self.index + '"]');
        }
        return container;
    },
     setCustomData : function (data) {
        var self = this;
        self.custom = true;
        self.customData = data;
        self.container = data.container;
        self.value = data.value;

    },
     hasCustomData : function () {
        var self = this;
        return (Object.keys(self.customData).length > 0) || self.custom;
    }
     */
});

Render.factory = function (key,config,type) {
    if (!type)
        type = 'input';
    var r = null;
    var className = "Render" + Utility.pascalCase(type);
    try {
        // estendo la classe per il supporto dell'overloading dei metodi passati in config;
        var localClass = window[className].extend(config);
        r = new localClass(key);
        r.className = className;
        if (!r.classData) {
            r.classData = type;
        }
        if (!r.classTemplate) {
            r.classTemplate = type;
        }
        
        // vecchio codice
        // r = new window[className](key,config);
        // r.className = className;
        // if (!r.classData) {
        //     r.classData = type;
        // }
        // if (!r.classTemplate) {
        //     r.classTemplate = type;
        // }
    } catch(e) {
        log.error(className,key,config,type,e);
        throw e;
    }
    return r;
}
/*
Render.objType = function (type) {
    var objType = null;
    try {
        objType = window["Render" + Utility.pascalCase(type)].prototype.type;
    } catch (e) {
        log.error("Render"+ Utility.pascalCase(type) + " " +  e);
        throw e;
    }
    return objType;
}

 */
Render.getClassName = function (type) {
    var className = null;
    try {
        className = "Render" + Utility.pascalCase(window["Render" + Utility.pascalCase(type)].prototype.className);
    } catch (e) {
        log.error("Render"+ Utility.pascalCase(type) + " " +  e);
        throw e;
    }
    return className;
}


Render.getClassData = function (type) {
    var classData = null;
    try {
        classData = "Render" + Utility.pascalCase(window["Render" + Utility.pascalCase(type)].prototype.classData);
    } catch (e) {
        log.error("Render"+ Utility.pascalCase(type) + " " +  e);
        throw e;
    }
    return classData;
}

Render.tinymceConfig = {
    forced_root_block : '',
};

Render.mymap = null;

Render.uid = 0;